'use client';

import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';

export const ConsultantDoctifyMiniWidget = ({
  doctifySlug,
  widgetId,
  justify = 'justify-center',
}: {
  doctifySlug: string;
  widgetId: string;
  justify?: string;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const injectedRef = useRef(false);

  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '400px 0px',
  });

  useEffect(() => {
    if (!inView || !doctifySlug || !widgetId) return;
    if (injectedRef.current) return;
    injectedRef.current = true;

    const container = document.getElementById(widgetId);
    if (!container) return;

    container.innerHTML = '';

    const scriptSrc = `https://www.doctify.com/get-script?widget_container_id=${widgetId}&type=horizontal-widget&tenant=athena-uk&language=en&profileType=specialist&layoutType=layoutA&slugs=${doctifySlug}&background=transparent`;

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    script.id = `doctify-script-${widgetId}`;
    script.onload = () => setIsLoading(false);
    script.onerror = () => setIsLoading(false);

    document.body.appendChild(script);
  }, [inView, doctifySlug, widgetId]);

  if (!doctifySlug || !widgetId) {
    return;
  }

  return (
    <div
      ref={ref}
      className={`doctify-container flex w-full items-center overflow-hidden ${justify}`}
    >
      <div
        id={widgetId}
        className="transition-opacity duration-500 ease-in-out"
        style={{
          opacity: isLoading ? 0 : 1,
          transform: 'scale(1.05)',
          transformOrigin: 'left center',
        }}
      />
      <style jsx global>{`
        #${widgetId} > div {
          margin-left: 0 !important;
          margin-right: 0 !important;
          width: 100% !important;
        }
      `}</style>
    </div>
  );
};
